<template>
  <RouterView></RouterView>
</template>

<script>
// Utilities
import { mapGetters, mapState } from "vuex";

export default {
  name: "App",

  computed: {
    ...mapGetters("cognito", ["isLoggedIn"]),
    ...mapState(["isReady"])
  },

  watch: {
    isReady(val) {
      if (val && this.isLoggedIn) this.$router.push("/");
    }
  }
};
</script>
